<template>
  <div class="widget w-market-depth-widget" :class="['font-size-' + fontSize, { bold: isFontBold }]">
    <c-widget-header hideLinkModeSend printView :wid="wid">
      <c-incremental-search slot="left" :ric="ric" @error="onSymbolSearchError" @change-ric="onSetRIC" />
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <w-control-bar :ric="ric" :view="view" @setRIC="onSetRIC" @updateView="onUpdateView" />
    <w-body :ric="ric" :view="view" />
    <b-toaster :name="notifierId"></b-toaster>
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import WControlBar from '@widgets/WMarketDepthWidget/WControlBar';
import WBody from '@widgets/WMarketDepthWidget/WBody';
import CIncrementalSearch from '@custom/CIncrementalSearch';
import widgetCommons from '@mixins/widgetCommons';

export default {
  name: 'w-market-depth-widget',
  mixins: [widgetCommons],
  components: {
    CWidgetHeader,
    CIncrementalSearch,
    WControlBar,
    WBody
  },
  props: {
    wid: {
      type: String,
      required: true
    }
  },
  computed: {
    ric() {
      return this.widgetStore.ric;
    },
    view() {
      return this.widgetStore.view;
    }
  },
  methods: {
    onSetRIC(value) {
      this.$store.commit('widget/' + this.wid + '/RIC_CHANGED', value);
    },
    onUpdateView(view) {
      this.$store.commit('widget/' + this.wid + '/VIEW_CHANGED', view);
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/widgets/market-depth-widget';
</style>
